import { Airror } from '@air/errors';

// https://linear.app/air/issue/ENG-136/update-isairrorinstance-to-not-use-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isAirrorInstance(result: any): result is Airror<any, any> {
  return result instanceof Airror;
}
